<template>
  <div>
    <a
      v-if="task.locTypeId != 35562"
      v-show="$store.state.app.detailModal.show"
      style="position: fixed; right: 20px; top: 20px; z-index: 102"
      @click="hideDetailModal()"
      class="close-menu float-end"
      ><i class="fa fa-times-circle fa-2x color-red-dark"></i
    ></a>
    <div
      id="menu-modal-view"
      :class="
        `menu menu-box-modal rounded-0 ${
          $store.state.app.detailModal.show ? 'menu-active' : ''
        }`
      "
      data-menu-width="cover"
      data-menu-height="cover"
      :style="
        `display: block; width: 100%; height: 100%; ${
          task.locTypeId == 35562 ? 'background: #555b7f' : ''
        }`
      "
    >
      <div
        class="header header-fixed header-logo-app"
        style="transform: translateX(0px); overflow: hidden"
      >
        <!-- <a data-menu="menu-main" class="header-icon header-icon-1"
        ><i class="fa-solid fa-close"></i></a
      > -->
        <a
          v-if="task.locTypeId == 35562"
          data-back-button=""
          class="header-title"
          :title="$t('photoAlbum')"
          style="margin-left: 20px !important"
          >{{ $t("photoAlbum") }}</a
        >
        <a
          v-else
          data-back-button=""
          class="header-title"
          :title="task.task"
          style="margin-left: 20px !important"
        >
          <span>
            {{ getLangText(task) }}
          </span>
        </a>
        <a
          v-if="task.locTypeId == 35562"
          v-show="$store.state.app.detailModal.show"
          style="position: fixed; right: 20px; top: 20px; "
          @click="hideDetailModal()"
          class="close-menu float-end"
          ><i class="fa fa-times-circle fa-2x color-red-dark"></i
        ></a>
      </div>
      <div style="margin-top: 5rem" v-if="task.locTypeId == 35562">
        <div
          v-for="(box, bi) in task.b.filter((x) => x.ot == 6)"
          :key="box.id"
          class=""
        >
          <div :key="bi"
            class="card card-style"
            style="-webkit-transform: inherit !important"
          >
            <div class="content mt-n3" style="margin-top: -1rem !important">
              <span
                class="mx-0 mt-4 card card-style bg-3"
                data-card-height="175"
                style="height: 175px; -webkit-transform: inherit !important"
                ><div class="demo-image__preview">
                  <!-- <img
                v-if="box.attaches != null && box.attaches.length > 0"
                :src="box.attaches[0].l"
              /> -->
                  <!-- <el-image
                  v-if="box.attaches != null && box.attaches.length > 0"
                  :preview-src-list="box.attaches.map((a) => a.l+'?w=600&mode=crop')"
                  :src="`${box.attaches[0].l}?w=600&mode=crop`"
                >
                </el-image> -->

                  <!-- <div
                  class="image"
                  v-for="(image, imageIndex) in box.attaches.map((a) => a.l+'?w=600&mode=crop')"
                  :key="imageIndex"
                  @click="activeBox = box; index= 0"
                  :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
                ></div> -->

                  <img
                    @click=" 
                      activeBox = box;
                      index = 0;
                    "
                    v-if="box.attaches != null && box.attaches.length > 0"
                    :preview-src-list="
                      box.attaches.map((a) => a.l + '?w=600&mode=crop')
                    "
                    :src="`${box.attaches[0].l}?w=600&mode=crop`"
                  />
                </div>
                <!-- <div class="p-3 card-bottom">
                <span class="opacity-50 float-end color-white"
                  >Өдөр Сар <span class="copyright-year">Он</span>
                  <i class="fa fa-clock ps-2"></i
                ></span>
              </div> -->
                <!-- <div class="card-overlay bg-gradient"></div> -->
              </span>
              <h2>{{ box.nm }}</h2>
              <p></p>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="$store.state.app.detailModal.flag == 3"></div>
      <div
        v-else
        class="card bg-18"
        :style="
          `background-image:url('${task.defaultAttachmentUrl}?w=600&mode=crop')`
        "
        data-card-height="350"
        style="height: 350px"
      >
        <div class="p-3 card-top no-click"></div>
        <div class="p-3 mt-2 card-top"></div>
        <div class="p-3 card-bottom">
          <h1
            class="color-white font-30"
            v-show="$store.state.app.detailModal.flag != 2"
          >
          {{ getLangText(task) }}
          </h1>
        </div>
      </div>
      <div
        v-if="$store.state.app.detailModal.flag == 3"
        v-html="getLangDesc(task)"
      ></div>
      <div v-else class="content">
        <div
          v-show="$store.state.app.detailModal.flag != 2"
          v-html="getLangDesc(task)"
        ></div>
        <div
          v-show="$store.state.app.detailModal.flag == 2"
          v-html="getLangText(task)"
        ></div>
      </div>
      <div
        v-show="$store.state.app.detailModal.show &&
          task.secondAttachmentUrl != 'https://res.gosmart.mn/media/noimg.png'
        "
      >
        <iframe v-if="task.secondAttachmentUrl!=undefined && task.secondAttachmentUrl!=null && task.secondAttachmentUrl != 'https://res.gosmart.mn/media/noimg.png'"
          id="theFrame"
          :src="`${myResBaseUrl}ubtz/web/viewer.html?file=` + task.secondAttachmentUrl"
          style="height:1000px; width:100%;"
        ></iframe>
      </div>
      <div class="divider divider-margins"></div>
    </div>

    <gallery
      :images="activeBox.attaches.map((a) => a.l + '?w=600&mode=crop')"
      :index="index"
      @close="index = null"
    ></gallery>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { request } from "@/api/all";

import VueGallery from "vue-gallery";

export default {
  components: {
    gallery: VueGallery,
  },
  data() {
    return {
      task: {},
      images: [],
      index: null,
      activeBox: {
        attaches: [],
      },
      myResBaseUrl: "https://res.gosmart.mn/"
    };
  },
  mounted(){
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  methods: {
    ...mapActions(["handleDetailModal"]),
    getLangText(task) {
      let lng = this.$i18n.locale;
      if (lng == "en") {
        return task.st5 ?? task.task;
      } else if (lng == "ru") {
        return task.st4 ?? task.task;
      } else if (lng == "cn") {
        return task.st6 ?? task.task;
      } else {
        return task.task;
      }
    },
    getLangDesc(task){
      //return task.taskDesc;
      let lng = this.$i18n.locale;
      if (lng == "en") {
        return task.f3 ?? task.taskDesc;
      } else if (lng == "ru") {
        return task.f2 ?? task.taskDesc;
      } else if (lng == "cn") {
        return task.f4 ?? task.taskDesc;
      } else {
        return task.taskDesc;
      }
    },
    init() {
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: this.$store.state.app.detailModal.id },
        store: this.$store,
      }).then((res) => {
        this.task = res.data.task;
        if (this.task.locTypeId == 35562) {
          this.task.b.forEach((box) => {
            request({
              api: { method: "GET", url: "Media/boxInAttachmentList" },
              params: { id: box.id, page: 0, size: 100 },
              store: this.$store,
            }).then((resatt) => {
              box.attaches = resatt.data.attachments;
            });
          });
        }
      });
    },
    hideDetailModal() {
      this.handleDetailModal({ show: false, id: 0 });
    },
  },
  computed: {
    taskId() {
      return this.$store.state.app.detailModal.id;
    },
  },
  watch: {
    taskId(val) {
      if (val > 0) {
        this.init();
      }
    },
  },
};
</script>
<style>
.el-image-viewer__wrapper {
  background: black;
}
</style>
